import styled, { css } from 'styled-components';

export const TableBase = styled.table`
  width: 100%;
  table-layout: fixed;
  min-height: 507px;

  // Чтобы границы ячеек не скролились в sticky head/foot
  // https://stackoverflow.com/a/53559396
  border-collapse: separate;

  font-size: 14px;
  line-height: 20px;
  color: rgba(9, 21, 38, 0.85);

  border-left: 1px solid rgba(9, 21, 38, 0.15);
  border-right: 1px solid rgba(9, 21, 38, 0.15);

  thead,
  tfoot {
    position: sticky;
    z-index: 1;
  }

  thead {
    top: 0;
  }

  tfoot {
    bottom: 0;
  }

  th,
  td {
    border-bottom: 1px solid rgba(9, 21, 38, 0.07);
    border-left: 1px solid rgba(9, 21, 38, 0.07);
    vertical-align: middle;
    text-align: center;
  }

  thead tr:first-child th {
    border-top: 1px solid rgba(9, 21, 38, 0.15);
  }

  tfoot tr:last-child td {
    border-top: 1px solid rgba(9, 21, 38, 0.07);
    border-bottom: 1px solid rgba(9, 21, 38, 0.15);
  }

  tr:first-child th:first-child,
  td:first-child {
    border-left: none;
  }

  th {
    font-weight: bold;
    color: rgba(9, 21, 38, 0.6);
    background: white;
  }

  tbody td {
    height: 52px;
    border-top: none;
    border-bottom: none;
  }

  tbody tr:last-child td {
    height: unset;
    min-height: 52px;
    vertical-align: top;
    padding: 14px 0;
  }

  tbody tr:nth-child(even) {
    background: rgba(9, 21, 38, 0.07);
  }

  tfoot td:first-child {
    font-weight: bold;
    font-size: 14px;
  }

  tfoot td {
    height: 54px;
    background: white;
  }
`;

export interface RowProps {
  lowResults?: boolean;
  noResults?: boolean;
  warning?: boolean;
}

export const ColoredCell = styled.td``;

export const ResultsRow = styled.tr<RowProps>`
  ${(props) =>
    props.lowResults &&
    css`
      ${ColoredCell} {
        color: #fb3e55;
      }
    `}
  ${(props) =>
    props.noResults &&
    css`
      td:not(:first-child) {
        color: rgba(9, 21, 38, 0.35);
      }
    `}
    ${(props) =>
    props.warning &&
    css`
      td {
        background: #ffd3cd;
      }
    `}
`;
